import React from 'react'

import SEO from '../../components/seo'

import Layout from '../../components/layout'

import HeaderImg from '../../components/HeaderImg/HeaderImg'
import ProjectOverview from '../../components/ProjectOverview/ProjectOverview'
import Testimonial from '../../components/Testimonial/Testimonial'
import TextBlock from '../../components/TextBlock/TextBlock'
import Slider from '../../components/Slider/Slider'
import Goals from '../../components/Goals/Goals'
import Outcomes from '../../components/Outcomes/Outcomes'
import BottomNav from '../../components/BottomNav/BottomNav'
import TestimonialVideo from '../../components/TestimonialVideo/TestimonialVideo'
import { JavascriptIcon } from '../../components/icons/JavascriptIcon'
import { TypescriptIcon } from '../../components/icons/TypescriptIcon'
import { InVisionIcon } from '../../components/icons/InVisionIcon'
import { AngularIcon } from '../../components/icons/AngularIcon'
import { HtmlIcon } from '../../components/icons/HtmlIcon'

const LightspeedVtPage = () => {
  const services = [
    {
      id: 1,
      text: 'Providing development resources',
    },
    {
      id: 2,
      text: 'Project management',
    },
    {
      id: 3,
      text: '6 people team',
    },
  ]

  const goals = [
    {
      id: 11,
      text:
        'Transform legacy parts of the training application into the latest, cutting-edge technology',
    },
    {
      id: 22,
      text:
        'Provide User Interface (UI) projects development based on custom design',
    },
    {
      id: 33,
      text: 'On-going support and collaboration',
    },
  ]

  const outcomes = [
    {
      id: 111,
      title: '12+',
      subtitle: 'months of ongoing partnership',
    },
    {
      id: 222,
      title: '7+',
      subtitle: 'projects delivery on-time',
    },
    {
      id: 333,
      title: '2,000,000',
      subtitle: 'unique users',
    },
  ]

  const slides = [
    {
      id: 2,
      img:
        'https://cdn.emersoft.co/emersoft-website/lightspeed/lsvt-slider-2.jpg',
      alt: 'Emersoft Team in LightSpeed VT office',
    },
    {
      id: 3,
      img:
        'https://cdn.emersoft.co/emersoft-website/lightspeed/lsvt-slider-3.jpg',
      alt: 'Emersoft Team visiting client in Las Vegas',
    },
    {
      id: 4,
      img:
        'https://cdn.emersoft.co/emersoft-website/lightspeed/lsvt-slider-1.jpg',
      alt: 'LightSpeed VT office',
    },
  ]

  const techs = [
    {
      id: 1111,
      icon: JavascriptIcon(),
    },
    {
      id: 6666,
      icon: TypescriptIcon(),
    },
    {
      id: 3333,
      icon: InVisionIcon(),
    },
    {
      id: 2222,
      icon: AngularIcon(),
    },
    {
      id: 4444,
      icon: HtmlIcon(),
    },
  ]

  return (
    <Layout>
      <SEO
        title="LightSpeed VT"
        keywords={[
          `Emersoft`,
          `application`,
          `react`,
          `London`,
          `digital agency`,
          `LightSpeed VT`,
          `Angular`,
        ]}
      />

      <HeaderImg
        header="header-img--lightspeedvt"
        icon={
          <svg
            width="260"
            height="38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48.392 8.291h5.968l-2.276 10.677h7.693l-.735 3.442h-13.66l3.01-14.119zM132.409 17.873a2.134 2.134 0 00.183 1.721 1.937 1.937 0 001.587.566c1.237 0 2.634-.293 2.875-1.428a.804.804 0 00-.117-.644c-.611-.9-7.242-1.564-8.791-3.226a2.752 2.752 0 01-.476-2.463c.658-3.09 3.801-4.477 9.473-4.477 6.027 0 7.497 1.661 6.954 4.574h-5.849a1.53 1.53 0 00-.391-1.564 2.613 2.613 0 00-1.662-.391c-1.258 0-2.025.468-2.18 1.191a.76.76 0 00.12.645c.734.88 7.155 1.506 8.681 3.19a2.724 2.724 0 01.559 2.619c-.595 2.796-3.455 4.594-9.91 4.594-7.696 0-7.579-2.285-7.136-4.906l6.08-.001zM151.934 11.262h1.808c1.708 0 2.165.606 1.916 1.781-.293 1.388-1.16 1.858-3.281 1.858h-1.218l.775-3.639zm-8.343 11.145h5.964l.967-4.537h4.671c2.982 0 5.543-1.232 6.276-4.674.782-3.676-1.346-4.908-4.761-4.908h-10.104l-3.013 14.119zM163.637 8.291h13.584l-.636 2.971h-7.808l-.555 2.6h7.32l-.634 2.973h-7.324l-.553 2.6h7.889l-.633 2.975h-13.662l3.012-14.119zM179.267 8.291h13.583l-.633 2.971h-7.812l-.555 2.6h7.322l-.636 2.973h-7.321l-.553 2.6h7.889l-.633 2.975h-13.662l3.011-14.119zM200.182 11.498h1.648c2.708 0 4.078 1.213 3.513 3.852-.564 2.638-2.448 3.851-5.156 3.851h-1.651l1.646-7.703zm-8.295 10.912h8.615c4.378 0 6.062-.549 8.017-1.877a8.408 8.408 0 003.005-5.067 5.928 5.928 0 00-.694-4.848c-1.525-1.955-4.156-2.327-8.336-2.327h-7.596l-3.011 14.119zM115.951 11.732H111.3l.734-3.44h15.269l-.735 3.44h-4.649L119.64 22.41h-5.964l2.275-10.678zM92.145 8.291h5.964l-1.113 5.223h5.906l1.114-5.223h5.964l-3.012 14.119h-5.964l1.164-5.456h-5.907l-1.162 5.456h-5.97L92.145 8.29zM83.01 12.593a1.546 1.546 0 00-.504-1.134 2.725 2.725 0 00-1.9-.567 4.9 4.9 0 00-4.87 4.242c-.58 2.72.258 4.674 3.221 4.674.981.046 1.96-.12 2.871-.488l.46-2.151h-3.452l.631-2.971h9.423l-1.59 7.45a49.48 49.48 0 01-9.84 1.132c-7.124 0-8.665-3.089-7.774-7.254 1.13-5.297 5.37-7.605 11.613-7.605 5.142 0 8.594 1.114 7.933 4.673l-6.223-.001zM64 8.291h5.963L66.95 22.41h-5.963L64 8.29zM215.835 8.291h6.575l1.63 8.914 5.534-8.914h6.084l-9.273 14.119h-7.301L215.835 8.29zM240.799 11.732h-4.652l.733-3.44h15.271l-.735 3.44h-4.651l-2.278 10.678h-5.963l2.275-10.678z"
              fill="#0086CB"
            />
            <path
              d="M44.76 26.026h2.134l-1.075 5.072h-2.136l1.076-5.072zm2.862 0h3.128l.983 3.4h.022l.721-3.4h1.858l-1.075 5.072h-3.031l-1.044-3.611h-.016l-.767 3.61h-1.858l1.079-5.07zm8.836 1.236h-1.662l.263-1.236h5.466l-.264 1.236H58.6l-.815 3.836h-2.137l.811-3.836zm4.79-1.236h4.861l-.227 1.068h-2.795l-.196.933h2.621l-.227 1.068h-2.62l-.196.934h2.824l-.228 1.069h-4.888l1.072-5.072zm7.505 1.026h.782c.519 0 .808.154.715.604-.098.477-.484.618-.94.618h-.815l.258-1.222zm-2.996 4.046h2.135l.392-1.842h.646c.73 0 .804.085.77.71l-.065 1.132h2.136l.087-1.701c.024-.512-.345-.684-.833-.703l.013-.07a1.58 1.58 0 001.352-1.2c.238-1.125-.562-1.398-1.945-1.398h-3.61l-1.078 5.072zm9.733-1.955l1.2-1.77.409 1.77h-1.61zm-3.413 1.955h2.092l.572-.844h2.62l.196.844h2.354l-1.507-5.072h-2.662l-3.665 5.072zm12.56-3.19c.078-.626-.13-.907-.705-.907-.83 0-1.263.717-1.442 1.564-.179.846-.051 1.564.778 1.564a1.102 1.102 0 001.186-.955h2.178c-.08.5-.339.955-.729 1.279a4.6 4.6 0 01-2.82.787c-2.542 0-3.158-1.047-2.813-2.67.254-1.202 1.109-2.67 3.947-2.67a3.303 3.303 0 012.459.66c.25.303.293.612.14 1.357l-2.179-.009zm4.42-.646h-1.662l.262-1.236h5.466l-.262 1.236h-1.662l-.814 3.836h-2.137l.809-3.836zm4.79-1.236h2.137l-1.075 5.072h-2.134l1.072-5.072zm2.57 0h2.355l.587 3.203 1.981-3.203h2.177l-3.324 5.072H97.58l-1.163-5.072zm7.528 0h4.861l-.227 1.068h-2.796l-.196.933h2.62l-.226 1.068h-2.62l-.196.934h2.822l-.224 1.069h-4.888l1.07-5.072zm8.647 0h2.353l.587 3.203 1.98-3.203h2.178l-3.319 5.072h-2.613l-1.166-5.072zm7.528 0h2.137l-1.076 5.072h-2.136l1.075-5.072zm4.781 1.026h.782c.519 0 .81.154.714.604-.098.477-.483.618-.94.618h-.814l.258-1.222zm-2.995 4.046h2.134l.391-1.842h.646c.73 0 .803.085.77.71l-.066 1.132h2.137l.087-1.701c.025-.512-.345-.684-.836-.703l.017-.07a1.58 1.58 0 001.352-1.2c.238-1.125-.56-1.398-1.945-1.398h-3.612l-1.075 5.072zm8.754-3.836h-1.662l.263-1.236h5.467l-.264 1.236h-1.662l-.816 3.836h-2.138l.812-3.836zm4.791-1.236h2.064l-.586 2.78c-.206.971.067 1.271.714 1.271.646 0 1.048-.3 1.254-1.27l.586-2.78h2.024l-.631 2.963a2.281 2.281 0 01-.799 1.482 4.106 4.106 0 01-2.703.759 2.914 2.914 0 01-2.384-.759c-.256-.345-.338-.684-.169-1.482l.63-2.964zm8.425 3.119l1.198-1.77.412 1.77h-1.61zm-3.415 1.955h2.094l.572-.844h2.621l.195.844h2.354l-1.508-5.072h-2.663l-3.665 5.072zm9.346-5.072h2.134l-.814 3.835h2.339l-.263 1.237h-4.475l1.079-5.072zm8.701 1.236h-1.662l.262-1.236h5.466l-.262 1.236h-1.662l-.816 3.836h-2.135l.809-3.836zm6.707-.21h.782c.521 0 .812.154.715.604-.098.477-.482.618-.938.618h-.816l.257-1.223zm-2.997 4.046h2.136l.391-1.842h.646c.73 0 .803.085.77.71l-.065 1.132h2.134l.089-1.701c.025-.512-.344-.684-.835-.703l.015-.07a1.585 1.585 0 001.353-1.201c.237-1.124-.561-1.397-1.945-1.397h-3.617l-1.072 5.072zm9.428-1.955l1.2-1.77.41 1.77h-1.61zm-3.415 1.955h2.095l.573-.844h2.619l.196.844h2.353l-1.508-5.072h-2.662l-3.666 5.072zm9.3-5.072h2.135l-1.075 5.072h-2.135l1.075-5.072zm2.863 0h3.128l.984 3.4h.021l.724-3.4h1.858l-1.075 5.072h-3.031l-1.046-3.611h-.014l-.767 3.61h-1.858l1.076-5.071zm7.43 0h2.137l-1.076 5.072h-2.134l1.073-5.072zm2.862 0h3.128l.986 3.4h.021l.723-3.4h1.857l-1.075 5.072h-3.031l-1.044-3.611h-.012l-.766 3.61h-1.857l1.07-5.071zm11.379 1.545a.55.55 0 00-.18-.408.97.97 0 00-.685-.204 1.76 1.76 0 00-1.742 1.525c-.208.977.091 1.678 1.152 1.678.352.017.703-.043 1.029-.176l.164-.772h-1.236l.228-1.068h3.37l-.567 2.678a17.712 17.712 0 01-3.519.407c-2.551 0-3.101-1.11-2.782-2.607.404-1.903 1.921-2.737 4.156-2.737 1.84 0 3.076.4 2.835 1.679l-2.223.005zm8.064 1.896a.768.768 0 00.063.618.699.699 0 00.57.205c.441 0 .943-.106 1.029-.513a.306.306 0 00-.042-.233c-.22-.322-2.593-.562-3.146-1.159a.99.99 0 01-.171-.88c.235-1.11 1.362-1.609 3.391-1.609 2.157 0 2.683.596 2.489 1.643h-2.095a.55.55 0 00-.139-.562.936.936 0 00-.596-.14c-.45 0-.726.168-.782.429a.288.288 0 00-.005.12c.008.04.023.078.047.111.264.315 2.561.54 3.108 1.145a.974.974 0 01.195.942c-.212 1.005-1.236 1.65-3.547 1.65-2.753 0-2.712-.821-2.555-1.759l2.186-.008zm6.224.113l-1.732-3.554h2.663l.609 2.092 1.564-2.092h2.274l-3.243 3.554-.322 1.518h-2.134l.321-1.518zm6.772-.113a.768.768 0 00.065.618.69.69 0 00.569.205c.442 0 .941-.106 1.028-.513a.29.29 0 00-.042-.233c-.219-.322-2.592-.562-3.147-1.159a.99.99 0 01-.169-.88c.235-1.11 1.361-1.609 3.39-1.609 2.158 0 2.683.596 2.49 1.643h-2.095a.55.55 0 00-.139-.562.943.943 0 00-.596-.14c-.449 0-.725.168-.782.429a.288.288 0 00.042.231c.264.315 2.564.54 3.109 1.145a.974.974 0 01.2.942c-.213 1.005-1.236 1.65-3.547 1.65-2.753 0-2.713-.821-2.555-1.759l2.179-.008zm6.311-2.205h-1.662l.262-1.236h5.466l-.263 1.236h-1.662l-.816 3.836h-2.135l.81-3.836zm4.79-1.236h4.862l-.227 1.068h-2.795l-.2.933h2.621l-.227 1.068h-2.614l-.196.934h2.823l-.226 1.069h-4.888l1.067-5.072zm5.588 0h3.239l.339 3.4h.013l1.75-3.4h3.251l-1.075 5.072h-1.982l.812-3.813h-.015l-2.2 3.813h-2.068l-.495-3.813h-.02l-.812 3.813h-1.812l1.075-5.072z"
              fill="#1A1818"
            />
            <path
              d="M254.692 8.3l-.119.575h.685l-.303 1.42h.732l.303-1.42h.684l.119-.574h-2.101zM259.041 8.3l-.727 1.155-.215-1.154h-.972l-.423 1.994h.652l.223-1.056.208 1.056h.675l.629-1.013-.215 1.013h.701L260 8.301h-.959z"
              fill="#0086CB"
            />
            <path
              d="M29.476 31.218a6.011 6.011 0 01-2.887-8.564l.125-.22a.662.662 0 00-.213-.865l-.06-.046a6.039 6.039 0 01-2.378-3.845 6.02 6.02 0 01.323-3.226c.046-.107.097-.22.14-.328l.091-.195.047-.098a6.084 6.084 0 012.995-2.72 5.918 5.918 0 002.195-1.334 5.24 5.24 0 001.136-1.912c.259-.689.383-1.42.366-2.156a6.021 6.021 0 00-.61-2.575 2.925 2.925 0 00-.233-.431c-.045-.07-.087-.152-.145-.133-.059.019-.058.049-.054.072a6.02 6.02 0 01-6.004 6.756h-.254a.66.66 0 00-.644.614l-.012.073a6.039 6.039 0 01-2.16 3.976c-.419.35-.878.648-1.368.89a6.061 6.061 0 01-6.147-.652 5.884 5.884 0 00-2.263-1.214 5.242 5.242 0 00-2.224-.008 5.75 5.75 0 00-2.04.783 6.026 6.026 0 00-1.912 1.834c-.095.132-.18.272-.252.418-.038.073-.086.152-.04.196.046.044.07.022.089.01.188-.144.383-.276.586-.398a6.047 6.047 0 018.283 2.14l.13.22a.663.663 0 00.856.243l.071-.029a6.048 6.048 0 017.497 2.183c.036.052.049.069.062.091a6.093 6.093 0 01.874 3.946 5.897 5.897 0 00.07 2.568 5.247 5.247 0 001.096 1.933 5.725 5.725 0 001.689 1.387c.78.436 1.65.692 2.542.75.162.017.326.021.489.012.083 0 .174 0 .186-.062.013-.061-.012-.073-.038-.084z"
              fill="#0083CA"
            />
            <path
              d="M10.68 8.994a13.305 13.305 0 014.758 3.065 2.805 2.805 0 002.456.823 3.032 3.032 0 002.655-3.369 2.922 2.922 0 00-.928-1.848 12.863 12.863 0 00-4.693-2.789 11.731 11.731 0 00-7.37.3 14.686 14.686 0 00-5.63 4.197 16.792 16.792 0 00-1.522 2.418 7.197 7.197 0 00-.36.757c-.07.181-.052.217.015.259.066.042.088.032.16-.034.072-.065.177-.16.517-.5a10.967 10.967 0 012.733-2.099c2.037-1.16 4.879-1.905 7.209-1.18zM28.951 37.148c-.098-.03-.227-.072-.692-.195a10.994 10.994 0 01-3.192-1.31c-2.025-1.182-4.1-3.265-4.64-5.644a13.29 13.29 0 01.262-5.655 2.81 2.81 0 00-.522-2.536 3.031 3.031 0 00-4.246-.605 2.923 2.923 0 00-1.13 1.73 12.858 12.858 0 00-.057 5.46 11.75 11.75 0 003.958 6.223 14.697 14.697 0 006.452 2.762c.948.115 1.904.15 2.857.104.28-.007.558-.03.835-.07.195-.029.214-.065.216-.141.002-.077-.007-.095-.1-.123zM37.821 3.362c-.37-.88-.813-1.729-1.326-2.535a7.362 7.362 0 00-.473-.69c-.122-.153-.163-.155-.23-.117-.068.037-.075.06-.053.154.021.094.05.235.173.699.325 1.11.474 2.265.44 3.422-.024 2.346-.808 5.181-2.606 6.826a13.327 13.327 0 01-5.042 2.572 2.806 2.806 0 00-1.947 1.704 3.032 3.032 0 001.58 3.987 2.907 2.907 0 002.062.126 12.843 12.843 0 004.772-2.652 11.752 11.752 0 003.446-6.522 14.722 14.722 0 00-.796-6.974z"
              fill="#0083CA"
            />
          </svg>
        }
        wrapper="header-img__img-wrapper--lightspeedvt"
      />
      <ProjectOverview
        title="LightSpeed VT"
        link="https://www.lightspeedvt.com/"
        category='E-Learning'
        services={services}
        technologies={techs}
        subtitle="Ongoing Partner Collaboration"
        paragraph1="LightSpeed VT is the most advanced interactive training system on Earth that helps companies, trainers, professional speakers, and entrepreneurial subject matter experts to maximize their training effectiveness, automate accountability, reduce costs and in many cases drive new revenue."
        paragraph2="The platform is used by such names and businesses as Ashley Furniture, UFC, Top Chef, Tony Robbins, Grant Cardone, and many more..."
      />
      <TestimonialVideo
        url="https://youtu.be/b4ApE2rR0qQ?si=siyqWanVkSgsWlew"
        author="Brad Lea"
        authorRole="CEO LightSpeed VT"
        thumbnail="https://cdn.emersoft.co/emersoft-website/lightspeed/lsvt-slider-4.jpg"
        alt="Brad Lea, CEO LightSpeed VT"
      />
      {/* <Testimonial
        paragraph="They are the secret weapon and the best assets in the world!"
        author="Brad Lea"
        authorRole="CEO LightSpeed VT"
      /> */}
      <TextBlock
        heading="Brief"
        paragraph1="Having been in the business for almost 20 years, the client had many legacy modules that were outdated and in some cases not supported by the latest browsers."
        paragraph2="They hired us to help scale their growing remote team, refresh existing components, and develop the new, state-of-art, user-friendly platform that is compatible with the mobile, tablet, and desktop devices."
      />
      <Slider slides={slides} />
      <Goals goalsList={goals} />
      <TextBlock
        heading="Our Process"
        paragraph1="Right from the beginning, we established a weekly meeting with stakeholders and key employees that would allow the demonstration of progress of work and accountability."
        paragraph2="Over a period of 12 months, we have been scaling the team gradually as we have been discovering the client’s short and long term needs."
      />
      <Outcomes outcomes={outcomes} />
      <BottomNav
        heading="See More"
        firstLink="/our-work/vooba"
        firstHeading="Vooba"
        secondLink="/our-work/radium"
        secondHeading="Radium"
      />
    </Layout>
  )
}

export default LightspeedVtPage
